import React, { useEffect, useState } from "react";
// import del from "../../src/assets/images/del1.png";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import Modal from "react-bootstrap/Modal";
import { Form, Row, Col, Spinner } from "react-bootstrap";
import CustomButton from "../../../components/button";
import { simplePostCall } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import QuizDetails from "./quizDetails";
import Params from "../../../config/Params";
import { toast } from "react-toastify";
import AssessmentStreamStatus from "./AssessmentStreamStatus";

export default function GeneratedQuestions(props) {
  const {
    handleNext,
    details,
    lessonsIds,
    topicsIds,
    setDetails,
    initialState,
    setTopics,
    selectedAssessmentDuration,
    selectedAssessmentImprovement,
    isBulk = false,
    
  } = props;

  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [questions, setQuestions] = useState([]);

  const [formData, setFormData] = useState({
    quizName: "",
    quizDuration: "",
  });

  const duration = [
    { label: "15 minutes", value: "15" },
    { label: "20 minutes", value: "20" },
    { label: "25 minutes", value: "25" },
    { label: "30 minutes", value: "30" },
    { label: "45 minutes", value: "45" },
    { label: "1 hour", value: "60" },
  ];

  const getQuestionFromAi = () => {
    setIsLoading(true);

    let payload = {
      num_questions: details?.noOfQuestion,
      curriculum_name: details?.curriculumName,
      syllabus_name: details?.syllabus,
      subject: details?.subjectName,
      grade: details?.gradeName,
      topic: details?.selectedSubTopics?.join(","),
      lesson_name: details?.selectedLessons?.join(","),
      difficulty: details?.difficulty,
    };

    console.log(payload);
    simplePostCall(
      ApiConfig.GENERATE_QUESTION_FROM_AI,
      JSON.stringify(payload)
    ).then((res) => {
      if (res?.success) {
        setQuestions(res?.assessment);
      }
      setIsLoading(false);
    });
  };

  
  useEffect(() => {
    console.log(details, lessonsIds, topicsIds);
if(!isBulk) {
    
    getQuestionFromAi();
}
  }, []);

  const handleSaveAiQusetions = () => {
    if (!formData?.quizName || !formData?.quizDuration) {
      toast.error("Please Enter Quiz Name And Duration");

      return;
    }

    let questoinList = questions?.map((ques) => {
      if (ques?.question_type === "Matching") {
        let answers = [];

        ques?.premises?.forEach((i) => {
          ques?.correct_answer?.forEach((name) => {
            if (name?.premise == i) {
              answers.push(name?.response);
            }
          });
        });
        return {
          question: ques?.question,
          question_type: "associate",
          instructions: "",
          choices: ques?.premises,
          choices1: ques?.responses,
          answer: answers,
          rationale: ques?.rationale,
          score: "1",
          difficulty_level: details?.difficulty,
          negativeScore: "0",
        };
      }

      if (ques?.question_type === "Ordering") {
        return {
          question: ques?.question,
          question_type: "order",
          instructions: "",
          choices: ques?.options,
          choices1: "",
          answer: ques?.correct_answer,
          rationale: ques?.rationale,
          score: "1",
          difficulty_level: details?.difficulty,
          negativeScore: "0",
        };
      }

      if (ques?.question_type === "Multiple Correct Answers") {
        return {
          question: ques?.question,
          question_type: "multipleselection",
          instructions: "",
          choices: ques?.options,
          choices1: "",
          answer: ques?.correct_answer,
          rationale: ques?.rationale,
          score: "1",
          difficulty_level: details?.difficulty,
          negativeScore: "0",
        };
      }

      return {
        question: ques?.question,
        question_type: ques?.question_type,
        instructions: "",
        options: ques?.options,
        correct_answer: ques?.correct_answer,
        rationale: ques?.rationale,
        score: "1",
        difficulty_level: details?.difficulty,
        negativeScore: "0",
      };
    });

    console.log(lessonsIds, details?.selectedLessons);

    let payload = {
      customer_id: Params.customer_id,
      api_key: Params.api_key,
      teacher_id: Params.teacher_id,
      title: formData?.quizName,
      description: "From Ai",
      class_division_id: details?.grade,
      curriculum: details?.curriculum,
      subject: details?.subject,
      type: "Yes",
      duration: formData?.quizDuration,
      improvement: "1",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      negative_mark: "no",
      lesson: lessonsIds.map((i) => i?.lessons_id),
      topic: topicsIds,
      assessment: questoinList,
    };

    simplePostCall(ApiConfig.SAVE_AI_QUESTIONS, JSON.stringify(payload)).then(
      (res) => {
        if (res?.result) {
          toast.success(res?.message);
          setShow(false);
          setDetails(initialState);
          handleNext(1);
          setTopics([]);
        }
      }
    );
  };

  const bulkPayload = isBulk ? {
  customer_id: Params.customer_id,
  api_key: Params.api_key,
  teacher_id: Params.teacher_id,
  curriculum_name: details?.curriculumName,
  subject: details?.subjectName,
  class_division_id: details?.grade,
  curriculum_id: details?.curriculum,
  subject_id: details?.subject,
  type: "Yes",
  duration: selectedAssessmentDuration?.assessment_duration,
  improvement: Number(selectedAssessmentImprovement.assessment_improvement),
  negative_mark: details?.negative_score,
  difficulty: details?.difficulty,
  grade: details?.gradeName,
  num_questions : details?.number_of_question,

  questionScore: details?.questionScore,
  negativeScore: details?.negativeScore ?  details?.negativeScore : 0,
} : {};

  return (
    <div style={{ backgroundColor: "white" }} className="canLisContentWrap">

    {isBulk ? (
   <AssessmentStreamStatus
    payload={bulkPayload}
    onComplete={() => {
      setIsLoading(false);
      toast.success("Assessment created successfully");
    }}
  />
) : (


      <div className="t-wrapper-div p-4">
        <h5 className="ja-1 mt-2">Review Questions</h5>
        {/* <p className="ja-2 mt-2">
                    Select 'Accept' for questions you want to include in the final assessment.
                </p> */}

        {isLoading ? (
          <>
            <div className="w-100 text-center">
          


              <p className="ja-2">
                Questions are generating. Please wait{" "}
                <Spinner animation="grow" size="sm" />
              </p>
            </div>
            <div className="w-100 text-center">
              <ShimmerSimpleGallery card imageHeight={300} row={3} col={1} />
            </div>
          </>
        ) : (
          <div
            className="hello"
            style={{
              height: "60vh",
              overflow: "scroll",
              scrollbarWidth: "none",
            }}
          >
            {questions.map((q, index) => (
              <div
                key={q.id}
                className="skills-box"
                style={{ marginTop: "10px" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <p
                    className="ja-2 mt-2"
                    style={{ fontSize: "14px", fontWeight: "400" }}
                  >
                    {q?.question}
                  </p>
                  {/* <img
                                        src={del}
                                        alt="delete"
                                        style={{ cursor: "pointer", height: "35px", width: "35px" }}
                                        title="Delete Question"
                                    /> */}
                </div>

                <ul className="ja-2" style={{ marginBottom: "5px" }}>
                  {q?.question_type === "Matching" && (
                    <div className="row">
                      <div className="col-md-4">
                        {q?.premises?.map((i) => {
                          return <li key={i}>{i}</li>;
                        })}
                      </div>
                      <div className="col-md-4">
                        {q?.responses?.map((i, index) => {
                          return <li key={index}>{i}</li>;
                        })}
                      </div>
                    </div>
                  )}
                  {(q?.question_type === "Single Correct Answer" ||
                    q?.question_type === "Ordering" ||
                    q?.question_type === "Multiple Correct Answers") &&
                    q.options.map((opt, i) => (
                      <li key={i}>
                        {i + 1}: {opt} {q.correct_answer === opt ? " *" : ""}
                      </li>
                    ))}
                </ul>
                <p className="ja-2" style={{ marginBottom: "5px" }}>
                  <strong
                    className="mainTitleColr"
                    style={{ fontWeight: "500" }}
                  >
                    Correct Answer:
                  </strong>{" "}
                  {q?.question_type === "Matching" && (
                    <>
                      {q?.correct_answer?.map((i) => {
                        return (
                          <li key={index} style={{ marginLeft: "15px" }}>
                            {i?.premise + "---" + i?.response}
                          </li>
                        );
                      })}
                    </>
                  )}
                  {q?.question_type === "Single Correct Answer" &&
                    q.correct_answer}
                  {(q?.question_type === "Ordering" ||
                    q?.question_type === "Multiple Correct Answers") &&
                    q?.correct_answer?.map((i) => {
                      return <li key={index}>{i}</li>;
                    })}
                </p>
                <p className="ja-2">
                  <strong
                    className="mainTitleColr"
                    style={{ fontWeight: "500" }}
                  >
                    Rationale:
                  </strong>{" "}
                  {q.rationale}
                </p>

                {/* <div
                                    className="button-group"
                                    style={{
                                        display: "flex",
                                        gap: "13px",
                                        justifyContent: "end",
                                    }}
                                >
                                    <CustomButton title={"More Like this"} buttonType="secondary" />
                                    <CustomButton title={"Replace"} buttonType="secondary" />
                                    <CustomButton title={"Regenerate"} buttonType="secondary" />
                                </div> */}
              </div>
            ))}
          </div>
        )}

        <div className="question-modal-footer mt-3">
          <CustomButton
            title="Back"
            buttonType="secondary"
            handleClick={() => handleNext(4)}
          />
          <CustomButton title="Submit" handleClick={() => setShow(true)} />
        </div>
      </div>
      )}

      {/* Modal for Quiz Details */}
      <Modal centered show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Quiz Details</h6>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate>
            <Form.Group controlId="quizName" className="mb-3">
              <Row className="align-items-center">
                <Col sm={3}>
                  <Form.Label className="job_size">Quiz Name</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Control
                    type="text"
                    placeholder="Enter Quiz Name"
                    value={formData.quizName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        quizName: e.target.value,
                      }))
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group controlId="quizDuration" className="mb-3">
              <Row className="align-items-center">
                <Col sm={3}>
                  <Form.Label className="job_size">Quiz Duration</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Select
                    value={formData.quizDuration}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        quizDuration: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select Quiz Duration</option>
                    {duration.map((d, i) => (
                      <option key={i} value={d.value}>
                        {d.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <CustomButton
            title="Close"
            buttonType="secondary"
            handleClick={() => setShow(false)}
          />
          <CustomButton title="Save" handleClick={handleSaveAiQusetions} />
        </Modal.Footer>
      </Modal>
    </div>
  );
}
